<pt-tab-with-scroll
  *ngIf="isTab"
  [groups]="groups"
  [activeSmallView]="activeSmallView"
  [selectedGroup]="selectedGroup"
  [activedEditWidgetId]="activedEditWidgetId"
  (changeGroup)="changeTab.emit($event)">
</pt-tab-with-scroll>

<div id="TOP"></div>

<div class="pteg-list" [class.pteg-list--tab]="isTab">
  <div class="pteg-item"
       [class.pteg-item--hidden]="!isTab && preliminaryRiskAssessmentGroupId === group.id"
       [attr.id]="ID_PREFIX + i"
       data-testid="doc-editor-group"
       *ngFor="let group of enabledGroups; index as i; last as latest">

    <!-- Header: solo in modalità LISTA -->
    <div class="pteg-header" *ngIf="!isTab"

         [class.pteg-header--last]="latest && !isOpen(group)"
         [class.pteg-body--open]="isOpen(group)"
         [ngClass]="{
          'pteg-header--open': isOpen(group)
        }">

      <!-- titolo disabilitato (editing in corso su un altro gruppo) -->
      <div class="pteg-panel-title pteg-panel-title--disabled"
           container="body"
           [ngbTooltip]="disabledChangeGroup && !isOpen(group)
             ? ('MESSAGE.BEFORE_CONTINUED_SAVE' | translate)
             : null"
           *ngIf="disabledChangeGroup && !isOpen(group)">
        {{ group.name }}
      </div>

      <!-- titolo cliccabile -->
      <div class="pteg-title-row"
           (click)="toggle(group)"
           *ngIf="!disabledChangeGroup || isOpen(group)">
        <div class="pteg-panel-title">
          {{ group.name }}
          <pt-w-help (click)="$event.stopPropagation()" [help]="group.help"></pt-w-help>
        </div>
        <div class="pteg-title-actions">
          <pt-icon [key]="IconExpand"
                   *ngIf="!isOpen(group)"
                   container="body"
                   ngbTooltip="{{ 'BUTTON.EXPAND' | translate }}"></pt-icon>
          <pt-icon [key]="IconCollapse"
                   *ngIf="isOpen(group)"
                   container="body"
                   ngbTooltip="{{ 'BUTTON.COLLAPSE' | translate }}"></pt-icon>
        </div>
      </div>
    </div>

    <!-- Body: sempre renderizzato (tutti i widget istanziati), mostrato solo
         se aperto (list) o selezionato (tab) -->
    <div class="pteg-body"
         [class.pteg-body--last]="latest"
         [class.pteg-body--open]="isOpen(group)">
      <p class="group-description"
         *ngIf="group.description"
         [innerHTML]="group.description"></p>

      <ng-container *ngFor="let widget of group?.widgets">
        <pt-template-editor-list-widget
          [widget]="widget"
          [status]="status"
          [lockAcquired]="lockAcquired">
        </pt-template-editor-list-widget>
      </ng-container>
    </div>
  </div>
</div>
